/*
 * <social-video>: poster + play button for merchant videos in the social sections.
 * - Play button: plays with sound and native controls; other playing videos pause.
 * - data-autoplay: plays muted while in view (skipped with reduced motion), pauses when out of view.
 * - Containers (tabs, sliders) can call el.pause() / el.resume() when the video is hidden / shown.
 */
(() => {
  if (customElements.get('social-video')) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class SocialVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('.social-video__play');
      if (!this.video) return;
      this.button?.addEventListener('click', () => this.play(true));
      this.video.addEventListener('play', () => {
        this.setAttribute('data-playing', '');
        if (this.video.controls) {
          document.querySelectorAll('social-video[data-playing]').forEach((el) => el !== this && el.video?.controls && el.pause());
        }
      });
      if (this.hasAttribute('data-autoplay')) {
        if (reducedMotion.matches) {
          this.removeAttribute('data-autoplay');
          return;
        }
        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.inView = entry.isIntersecting;
            if (this.inView && this.isShown()) this.play(false);
            else if (!this.video.controls) this.video.pause();
          },
          { threshold: 0.25 }
        );
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    isShown() {
      return !this.closest('[hidden], [aria-hidden="true"]');
    }

    play(withSound) {
      if (withSound) {
        this.video.muted = false;
        this.video.controls = true;
        this.removeAttribute('data-autoplay');
      }
      if (this.video.preload === 'none') this.video.preload = 'auto';
      const p = this.video.play();
      if (p && p.catch) p.catch(() => {});
    }

    pause() {
      this.video?.pause();
    }

    resume() {
      if (this.hasAttribute('data-autoplay') && this.inView !== false) this.play(false);
    }
  }
  customElements.define('social-video', SocialVideo);
})();
